<template>
  <div class="font_box" v-loading.fullscreen.lock="showLoading">
  <div class="box_operation">
    <div class="input_box">
      <el-input placeholder="请输入语音名称/标签" v-model="searchName" class="input-with-select"></el-input>
    </div>

    <div class="input_box">
      <el-select v-model="pageCount" placeholder="请选择" @change="onPageCountChange">
        <el-option
            v-for="item in pageNumList"
            :key="item.value"
            :label="item.label"
            :value="item.value">
        </el-option>
      </el-select>
    </div>
    <!--操作列表-->
    <div class="btn_box">
      <el-button type="primary" @click="search">搜索</el-button>
    </div>
    <div class="btn_box">
      <el-button type="primary" @click="addFont">添加</el-button>
    </div>
    <div class="btn_box">
      <el-button type="danger" @click="getAudioPackList">刷新</el-button>
    </div>
  </div>
  <div class="box_operation">
    <div class="btn_box">
      <el-button type="primary" @click="openBatchDialog">批量上传</el-button>
    </div>
    <div class="btn_box">
      <el-button type="primary" plain @click="saveAllAudioTags" :disabled="changedTagCount === 0">
        保存全部标签{{ changedTagCount > 0 ? `(${changedTagCount})` : '' }}
      </el-button>
    </div>
  </div>
    <div class="data_box">
      <el-table
          class="table"
          @sort-change="sortChange"
          border
          :data="audioPackList"
          style="width: 100%">
        <el-table-column
            align="center"
            sortable="custom"
            prop="id"
            label="id"
            width="80">
        </el-table-column>
        <el-table-column
            align="center"
            label="语音"
            width="320">
          <template slot-scope="scope">
            <audio ref="audio" controls="" :src="scope.row.url"/>
          </template>
        </el-table-column>
        <el-table-column
            align="center"
            sortable="custom"
            prop="name"
            label="语音名称"
            width="200">
          <template slot-scope="scope">
            <el-input
                v-model="scope.row.name"
                placeholder="语音名称"
                :disabled="!canEditToday(scope.row.createTime)"
                @keyup.enter.native="canEditToday(scope.row.createTime) && updateAudioField(scope.row, 'name')"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column
            align="center"
            sortable="custom"
            prop="tag"
            label="分组标签"
            width="200">
          <template slot-scope="scope">
            <el-input
                v-model="scope.row.tag"
                placeholder="分组标签"
                :disabled="!canEditToday(scope.row.createTime)"
                @keyup.enter.native="canEditToday(scope.row.createTime) && updateAudioField(scope.row, 'tag')"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column
            align="center"
            sortable="custom"
            prop="moreTag"
            label="更多标签"
            width="240">
          <template slot-scope="scope">
            <el-input
                v-model="scope.row.moreTag"
                placeholder="更多标签"
                :disabled="!canEditToday(scope.row.createTime)"
                @keyup.enter.native="canEditToday(scope.row.createTime) && updateAudioField(scope.row, 'moreTag')"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column
            align="center"
            sortable="custom"
            prop="heat"
            label="总热度"
            width="100">
        </el-table-column>
        <el-table-column
            align="center"
            sortable="custom"
            prop="hotness"
            label="最近热度"
            width="100">
        </el-table-column>
        <el-table-column
            align="center"
            sortable="custom"
            prop="cloneHeat"
            label="克隆总热度"
            width="120">
        </el-table-column>
        <el-table-column
            align="center"
            sortable="custom"
            prop="cloneHotness"
            label="克隆最近热度"
            width="130">
        </el-table-column>
        <el-table-column
            align="center"
            sortable="custom"
            prop="supportClone"
            label="支持克隆"
            width="120">
          <template slot-scope="scope">
            <el-select 
                v-model="scope.row.supportClone" 
                :disabled="!canEditToday(scope.row.createTime)"
                @change="updateAudioField(scope.row, 'supportClone')"
                style="width: 100px;">
              <el-option label="支持" :value="1"></el-option>
              <el-option label="不支持" :value="0"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
            align="center"
            sortable="custom"
            prop="size"
            label="大小(kb)"
            width="100">
          <template slot-scope="scope">
            <p>{{ (scope.row.size / 1024).toFixed(2) }}</p>
          </template>
        </el-table-column>
        <el-table-column
            align="center"
            sortable="custom"
            prop="createTime"
            label="创建时间"
            width="180">
        </el-table-column>
        <el-table-column
            align="center"
            sortable="custom"
            prop="pid"
            label="父级ID"
            width="80">
        </el-table-column>
        <el-table-column
            align="center"
            sortable="custom"
            prop="isLock"
            label="是否加锁"
            width="100">
          <template slot-scope="scope">
            <el-select 
                v-model="scope.row.isLock" 
                :disabled="!canEditToday(scope.row.createTime)"
                @change="updateAudioField(scope.row, 'isLock')"
                style="width: 80px;">
              <el-option label="无锁" :value="0"></el-option>
              <el-option label="加锁" :value="1"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
            align="center"
            sortable="custom"
            prop="url"
            label="文件地址"
            width="200">
          <template slot-scope="scope">
            <el-input
                v-model="scope.row.url"
                placeholder="文件地址"
                @keyup.enter.native="updateAudioField(scope.row, 'url')"
                readonly>
            </el-input>
          </template>
        </el-table-column>
        <el-table-column
            min-width="240"
            align="center"
            label="操作">
          <template slot-scope="scope">
            <el-button type="success" size="medium" icon="el-icon-download" @click="downFont(scope.row)"></el-button>
            <el-button v-if="canEditToday(scope.row.createTime)" type="primary" size="medium" icon="el-icon-edit" @click="updateFont(scope.row)"></el-button>
            <el-button v-if="canEditToday(scope.row.createTime)" type="danger" size="medium" icon="el-icon-delete" @click="delFont(scope.row)"></el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="page">
        <el-pagination
            background
            :page-size="5"
            :current-page="pageNo"
            layout="prev, pager, next"
            :page-count="pageSum"
            @current-change="changePage">
        </el-pagination>
      </div>
    </div>
    <el-dialog :title="dialogTitle"
               @close="closeDialog"
               top="5vh"
               :visible.sync="showDialog"
               :close-on-click-modal="false"
               width="800px"
               :destroy-on-close="true"
               :fullscreen="false">
      <AudioPackEdit v-on:saveStatus="saveStatus" :audioPack="selectAudioPack" :is-update="isUpdate"/>
    </el-dialog>
    <el-dialog
        title="批量上传语音包"
        :visible.sync="showBatchDialog"
        :close-on-click-modal="false"
        width="900px"
        top="5vh"
        @close="cancelBatchUpload">
      <el-form label-width="120px">
        <el-form-item label="文件选择">
          <el-upload
              drag
              class="upload-demo"
              action="none"
              multiple
              :file-list="batchFileList"
              :on-change="onBatchFileChange"
              :on-remove="onBatchFileRemove"
              :before-upload="beforeBatchUpload"
              :auto-upload="false"
              :limit="50"
              accept="audio/*">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖拽到此处，或<em>点击选择语音文件(≤50)</em></div>
            <div class="el-upload__tip">支持多选与拖拽，单文件不超过20MB</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="统一分组标签" v-if="batchFileList.length">
          <el-input v-model="batchUploadTag" placeholder="请输入分组标签"></el-input>
        </el-form-item>
        <el-form-item label="上传进度" v-if="batchTasks.length">
          <el-table class="table" border :data="batchTasks" style="width: 100%">
            <el-table-column align="center" prop="name" label="文件名" width="320"></el-table-column>
            <el-table-column align="center" label="大小(kb)" width="120">
              <template slot-scope="scope">
                <span>{{ (scope.row.size / 1024).toFixed(2) }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="进度">
              <template slot-scope="scope">
                <el-progress :percentage="scope.row.progress" :status="scope.row.progressStatus"></el-progress>
              </template>
            </el-table-column>
            <el-table-column align="center" label="状态" width="120">
              <template slot-scope="scope">
                <el-tag :type="statusTagType(scope.row.status)">{{ statusText(scope.row.status) }}</el-tag>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <div class="dialog-footer" style="text-align: right;">
          <el-button @click="cancelBatchUpload">取消</el-button>
          <el-button type="primary" :disabled="!canStartBatch" @click="startBatchUpload">确认上传</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import AudioPackEdit from "./AudioPackEdit";
import {mapState} from "vuex";

const AUDIO_PACK_PENDING_SEARCH_KEY = 'audioPackManagerSearchName';

export default {
  name: "audioPackManager",
  components: {
    AudioPackEdit
  },
  data: function () {
    return {
      dialogTitle: "",
      showLoading: false,
      audioPackList: [],
      pageNo: 1,
      pageSum: 1,
      pageCount: 100,//每页显示数据量
      pageNumList: [{
        id: 0,
        label: '每页20条',
        value: 20,
      }, {
        id: 1,
        label: '每页50条',
        value: 50
      }, {
        id: 2,
        label: '每页100条',
        value: 100
      }, {
        id: 3,
        label: '每页200条',
        value: 200
      }],
      searchName: "",
      orderType: 0,//排序规则
      showDialog: false,//弹框是否显示
      isUpdate: false,
      selectAudioPack: {},
      showBatchDialog: false,
      batchCancelSource: null,
      batchUploadTag: "",
      batchFileList: [],
      batchTasks: [],
      uploadingBatch: false,
      concurrency: 5,
      chunkSize: 4 * 1024 * 1024,
      retryLimit: 3
    }
  },
  computed: {
    ...mapState("userOptions", ["userInfo"]),
    isMaterialCollaborator() {
      return this.userInfo && this.userInfo.accountType === "material_collaborator"
    },
    canStartBatch: function () {
      return this.batchUploadTag && this.batchTasks.length > 0 && !this.uploadingBatch;
    },
    changedTagCount() {
      const that = this
      return this.audioPackList.filter(function (item) {
        return that.canEditToday(item.createTime) && that.hasAudioTagChanged(item)
      }).length
    }
  },
  methods: {
    canEditToday(timeValue) {
      if (!this.isMaterialCollaborator) {
        return true;
      }
      return this.isToday(timeValue);
    },
    isToday(timeValue) {
      if (!timeValue) {
        return false;
      }
      const parsedTime = this.parseMaterialTime(timeValue);
      if (parsedTime === null) {
        return false;
      }
      const now = Date.now();
      const oneDayMs = 24 * 60 * 60 * 1000;
      return parsedTime >= now || now - parsedTime <= oneDayMs;
    },
    parseMaterialTime(timeValue) {
      if (timeValue instanceof Date) {
        const timestamp = timeValue.getTime();
        return Number.isNaN(timestamp) ? null : timestamp;
      }

      if (typeof timeValue === 'number') {
        return timeValue < 1000000000000 ? timeValue * 1000 : timeValue;
      }

      const normalizedValue = String(timeValue).trim();
      if (!normalizedValue) {
        return null;
      }

      let parsedTime = Date.parse(normalizedValue);
      if (!Number.isNaN(parsedTime)) {
        return parsedTime;
      }

      parsedTime = Date.parse(normalizedValue.replace(/-/g, '/'));
      return Number.isNaN(parsedTime) ? null : parsedTime;
    },
    openBatchDialog: function () {
      this.batchUploadTag = "";
      this.batchFileList = [];
      this.batchTasks = [];
      this.uploadingBatch = false;
      this.batchCancelSource = axios.CancelToken.source();
      this.showBatchDialog = true;
    },
    cancelBatchUpload: function () {
      try {
        if (this.batchCancelSource) this.batchCancelSource.cancel('用户取消上传');
      } catch (e) {}
      this.uploadingBatch = false;
      this.showBatchDialog = false;
      this.batchTasks = [];
      this.batchFileList = [];
    },
    /**
     * 获取字体列表
     */
    getAudioPackList: function () {
      this.showLoading = true;
      const that = this;
      const params = {
        "isPage": 1,
        "pageNo": this.pageNo,
        "pageCount": this.pageCount,
        "orderType": this.orderType,
        "searchName": this.searchName,
      }
      this.$request.post("/audio/getAudioPackList", params)
          .then(function (data) {
            if (data.status === 200) {
              that.audioPackList = data.data.records
              that.snapshotAudioTags(that.audioPackList)
              that.pageSum = data.data.pages
              that.showLoading = false
            } else {
              that.showMsg(data.data)
            }
          }).catch(function (err) {
        that.showLoading = false
        that.showMsg("网络错误," + err)
      })
    },
    /**
     * 显示错误消息
     * @param title
     */
    showMsg: function (title) {
      this.$confirm(title, "提示", {
        confirmButtonText: '确定',
        showClose: false,
        showCancelButton: false,
        center: true,
        type: 'error'
      })
    },
    /**
     * 页面改变触发
     * @param pageNo 改变的页码
     */
    changePage: function (pageNo) {
      this.pageNo = pageNo;
      this.getAudioPackList()
    },
    search: function () {
      this.pageNo = 1;
      this.getAudioPackList()
    },
    /**
     * 每页显示数量改变
     */
    onPageCountChange: function () {
      this.pageNo = 1;
      this.getAudioPackList()
    },
    beforeBatchUpload: function (file) {
      const isAudio = file.type && file.type.startsWith('audio/');
      const isLt20M = file.size / 1024 / 1024 <= 20;
      return isAudio && isLt20M;
    },
    onBatchFileChange: function (file, fileList) {
      this.batchFileList = fileList.slice(0, 50);
      this.batchTasks = this.batchFileList.map((f, idx) => ({
        id: Date.now() + '_' + idx,
        file: f.raw || f,
        name: (f.name || (f.raw && f.raw.name)) || '',
        size: (f.size || (f.raw && f.raw.size)) || 0,
        progress: 0,
        progressStatus: 'normal',
        status: 'queued',
        uploadedChunks: 0,
        totalChunks: 0,
        hash: '',
        retries: 0
      }));
    },
    onBatchFileRemove: function (file, fileList) {
      this.batchFileList = fileList;
      const name = file.name;
      this.batchTasks = this.batchTasks.filter(t => t.name !== name);
    },
    statusTagType: function (status) {
      if (status === 'completed') return 'success';
      if (status === 'failed') return 'danger';
      if (status === 'uploading') return 'warning';
      return 'info';
    },
    statusText: function (status) {
      if (status === 'completed') return '完成';
      if (status === 'failed') return '失败';
      if (status === 'uploading') return '上传中';
      return '等待';
    },
    startBatchUpload: async function () {
      if (!this.batchTasks.length || !this.batchUploadTag) return;
      this.uploadingBatch = true;
      let active = 0;
      let cursor = 0;
      const next = () => {
        if (!this.uploadingBatch) return;
        while (active < this.concurrency && cursor < this.batchTasks.length) {
          const task = this.batchTasks[cursor++];
          active++;
          this.uploadSingleTask(task).then(() => {
            active--;
            next();
          }).catch(() => {
            active--;
            next();
          });
        }
        if (active === 0 && cursor >= this.batchTasks.length) {
          this.uploadingBatch = false;
          this.onBatchDone();
        }
      };
      next();
    },
    onBatchDone: function () {
      const successCount = this.batchTasks.filter(t => t.status === 'completed').length;
      const failCount = this.batchTasks.filter(t => t.status === 'failed').length;
      const type = failCount === 0 ? 'success' : 'error';
      const title = failCount === 0 ? '全部上传成功' : `成功 ${successCount} 个，失败 ${failCount} 个`;
      this.$confirm(title, '提示', {
        confirmButtonText: '确定',
        showClose: false,
        showCancelButton: false,
        center: true,
        type: type
      }).then(() => {
        this.showBatchDialog = false;
        this.getAudioPackList();
      });
    },
    computeFileHash: async function (file) {
      const buffer = await file.arrayBuffer();
      const hashBuffer = await crypto.subtle.digest('SHA-256', buffer);
      const hashArray = Array.from(new Uint8Array(hashBuffer));
      return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
    },
    createChunks: function (file) {
      const size = this.chunkSize;
      const chunks = [];
      let start = 0;
      let index = 0;
      while (start < file.size) {
        const end = Math.min(start + size, file.size);
        chunks.push({ index, blob: file.slice(start, end) });
        start = end;
        index++;
      }
      return chunks;
    },
    saveChunkProgress: function (hash, idx) {
      const key = 'audio_chunk_' + hash;
      const raw = localStorage.getItem(key);
      const set = raw ? JSON.parse(raw) : [];
      if (!set.includes(idx)) set.push(idx);
      localStorage.setItem(key, JSON.stringify(set));
    },
    loadChunkProgress: function (hash) {
      const key = 'audio_chunk_' + hash;
      const raw = localStorage.getItem(key);
      return raw ? JSON.parse(raw) : [];
    },
    clearChunkProgress: function (hash) {
      const key = 'audio_chunk_' + hash;
      localStorage.removeItem(key);
    },
    uploadChunkOnce: async function (task, chunk) {
      const fd = new FormData();
      fd.append('file', chunk.blob);
      fd.append('fileName', task.name);
      fd.append('fileHash', task.hash);
      fd.append('chunkIndex', chunk.index);
      fd.append('totalChunks', task.totalChunks);
      fd.append('tag', this.batchUploadTag);
      const res = await this.$request.post('/audio/uploadChunk', fd, { timeout: 120000, cancelToken: this.batchCancelSource && this.batchCancelSource.token });
      if (res && res.status === 200) return true;
      return false;
    },
    uploadChunkWithRetry: async function (task, chunk) {
      for (let attempt = 0; attempt < this.retryLimit; attempt++) {
        try {
          const ok = await this.uploadChunkOnce(task, chunk);
          if (ok) return true;
        } catch (e) {}
        await new Promise(r => setTimeout(r, 1000 * Math.pow(2, attempt)));
      }
      return false;
    },
    finalizeMerge: async function (task) {
      const fd = new FormData();
      fd.append('fileHash', task.hash);
      fd.append('fileName', task.name);
      fd.append('name', task.name.replace(/\.[^/.]+$/, ''));
      fd.append('tag', this.batchUploadTag);
      fd.append('moreTag', '');
      fd.append('heat', 4000);
      fd.append('supportClone', 1);
      fd.append('pid', '');
      fd.append('isLock', 0);
      fd.append('hotness', 0);
      fd.append('cloneHeat', 0);
      fd.append('cloneHotness', 0);
      const res = await this.$request.post('/audio/mergeChunks', fd, { timeout: 120000, cancelToken: this.batchCancelSource && this.batchCancelSource.token });
      if (res && res.status === 200) return true;
      return false;
    },
    singleUploadFallback: async function (task) {
      const fd = new FormData();
      fd.append('file', task.file);
      fd.append('name', task.name.replace(/\.[^/.]+$/, ''));
      fd.append('tag', this.batchUploadTag);
      fd.append('moreTag', '');
      fd.append('heat', 4000);
      fd.append('supportClone', 1);
      fd.append('pid', '');
      fd.append('isLock', 0);
      fd.append('hotness', 0);
      fd.append('cloneHeat', 0);
      fd.append('cloneHotness', 0);
      const res = await this.$request.post('/audio/addAudioPack', fd, { timeout: 180000, cancelToken: this.batchCancelSource && this.batchCancelSource.token });
      return res && res.status === 200;
    },
    uploadSingleTask: async function (task) {
      task.status = 'uploading';
      try {
        task.hash = await this.computeFileHash(task.file);
        const doneSet = this.loadChunkProgress(task.hash);
        const chunks = this.createChunks(task.file);
        task.totalChunks = chunks.length;
        for (let i = 0; i < chunks.length; i++) {
          const c = chunks[i];
          if (doneSet.includes(c.index)) {
            task.uploadedChunks++;
            task.progress = Math.floor(task.uploadedChunks / task.totalChunks * 100);
            continue;
          }
          const ok = await this.uploadChunkWithRetry(task, c);
          if (!ok) throw new Error('chunk_fail');
          this.saveChunkProgress(task.hash, c.index);
          task.uploadedChunks++;
          task.progress = Math.floor(task.uploadedChunks / task.totalChunks * 100);
        }
        const merged = await this.finalizeMerge(task);
        if (!merged) {
          const fallback = await this.singleUploadFallback(task);
          if (!fallback) throw new Error('finalize_fail');
        }
        this.clearChunkProgress(task.hash);
        task.progress = 100;
        task.progressStatus = 'success';
        task.status = 'completed';
      } catch (e) {
        const ok = await this.singleUploadFallback(task);
        if (ok) {
          task.progress = 100;
          task.progressStatus = 'success';
          task.status = 'completed';
          return;
        }
        task.progressStatus = 'exception';
        task.status = 'failed';
      }
    },
    addFont: function () {
      this.dialogTitle = "添加语音文件"
      this.isUpdate = false
      this.selectAudioPack = { supportClone: 1 }
      this.showDialog = true
    },
    /**
     * 弹框关闭
     */
    closeDialog: function () {
      this.selectAudioPack = {}
    },
    saveStatus: function (flag) {
      if (flag) {
        this.pageNo = 1;
        this.searchName = "";
        this.orderType = 0;
        this.getAudioPackList()
      }
      this.showDialog = false
    },
    /**
     * 排序规则改变
     */
    sortChange: function ({column, prop, order}) {
      console.log(column + "- " + prop + " " + order)
      switch (order) {
        case "ascending"://升序
          if (prop === 'heat') {
            this.orderType = 3;
          } else if (prop === 'createTime') {
            this.orderType = 1;
          } else if (prop === 'id') {
            this.orderType = 5;
          } else if (prop === 'name') {
            this.orderType = 7;
          } else if (prop === 'tag') {
            this.orderType = 9;
          } else if (prop === 'moreTag') {
            this.orderType = 11;
          } else if (prop === 'hotness') {
            this.orderType = 13;
          } else if (prop === 'cloneHeat') {
            this.orderType = 15;
          } else if (prop === 'cloneHotness') {
            this.orderType = 17;
          } else if (prop === 'supportClone') {
            this.orderType = 19;
          } else if (prop === 'size') {
            this.orderType = 21;
          } else if (prop === 'pid') {
            this.orderType = 23;
          } else if (prop === 'isLock') {
            this.orderType = 25;
          } else if (prop === 'url') {
            this.orderType = 27;
          }
          break;
        case "descending":
        case null://降序
          if (prop === 'heat') {
            this.orderType = 2;
          } else if (prop === 'createTime') {
            this.orderType = 0;
          } else if (prop === 'id') {
            this.orderType = 4;
          } else if (prop === 'name') {
            this.orderType = 6;
          } else if (prop === 'tag') {
            this.orderType = 8;
          } else if (prop === 'moreTag') {
            this.orderType = 10;
          } else if (prop === 'hotness') {
            this.orderType = 12;
          } else if (prop === 'cloneHeat') {
            this.orderType = 14;
          } else if (prop === 'cloneHotness') {
            this.orderType = 16;
          } else if (prop === 'supportClone') {
            this.orderType = 18;
          } else if (prop === 'size') {
            this.orderType = 20;
          } else if (prop === 'pid') {
            this.orderType = 22;
          } else if (prop === 'isLock') {
            this.orderType = 24;
          } else if (prop === 'url') {
            this.orderType = 26;
          }
          break;
      }
      this.pageNo = 1;//重置页码
      this.getAudioPackList()
    },
    updateFont: function (audioPack) {
      audioPack.fileList = [{name: audioPack.name, url: audioPack.url}]
      this.dialogTitle = "修改语音包"
      this.isUpdate = true
      this.showDialog = true
      this.selectAudioPack = audioPack
    },
    delFont: function (audioPack) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        cancelButtonClass: "messagebox-off-button-color",
        confirmButtonClass: "messagebox-ok-button-color"
      }).then(() => {
        this.del(audioPack)
      }).catch(() => {
      });
    },
    del: function (audioPack) {
      this.showLoading = true;
      const that = this;
      const params = {
        "id": audioPack.id,
        "originUrl": audioPack.url
      }
      this.$request.post("/audio/deleteAudioPack", params)
          .then(function (data) {
            that.showLoading = false;
            if (data.status === 200) {
              that.$confirm("删除成功", "提示", {
                confirmButtonText: '确定',
                showClose: false,
                showCancelButton: false,
                center: true,
                type: 'success'
              }).then(function () {
                that.getAudioPackList()
              }).catch(function () {

              })
            } else {
              that.showMsg(data.data)
            }
          }).catch(function (err) {
        that.showLoading = false;
        that.showMsg("网络错误")
      })
    },
    downFont: function (font) {
      window.location.href = font.url
    },
    snapshotAudioTags: function (list) {
      list.forEach(function (item) {
        item._originalTag = item.tag || ''
        item._originalMoreTag = item.moreTag || ''
      })
    },
    hasAudioTagChanged: function (audioPack) {
      return (audioPack.tag || '') !== (audioPack._originalTag || '') ||
          (audioPack.moreTag || '') !== (audioPack._originalMoreTag || '')
    },
    requestUpdateAudioPack: function (audioPack) {
      const params = new FormData()
      params.append("id", audioPack.id)
      params.append("name", audioPack.name || '')
      params.append("tag", audioPack.tag || '')
      params.append("moreTag", audioPack.moreTag || '')
      params.append("originUrl", audioPack.url)
      params.append("heat", audioPack.heat || 0)
      params.append("supportClone", audioPack.supportClone || 0)
      params.append("pid", audioPack.pid || 0)
      params.append("isLock", audioPack.isLock || 0)
      params.append("hotness", audioPack.hotness || 0)
      params.append("cloneHeat", audioPack.cloneHeat || 0)
      params.append("cloneHotness", audioPack.cloneHotness || 0)
      const that = this
      return this.$request.post("/audio/updateAudioPack", params).then(function (data) {
        if (data.status === 200) {
          audioPack._originalTag = audioPack.tag || ''
          audioPack._originalMoreTag = audioPack.moreTag || ''
          return data
        }
        return Promise.reject(new Error(data.data || '修改失败'))
      }).catch(function (err) {
        const msg = typeof err === 'string' ? err : (err && err.message ? err.message : '修改失败')
        return Promise.reject(new Error(msg))
      })
    },
    /**
     * 更新语音包字段
     * @param audioPack 语音包对象
     * @param field 要更新的字段名
     */
    updateAudioField: function (audioPack, field) {
      this.showLoading = true
      const that = this
      this.requestUpdateAudioPack(audioPack).then(function () {
        that.showLoading = false
        that.$message.success('修改成功')
      }).catch(function (err) {
        that.showLoading = false
        that.showMsg(err.message)
      })
    },
    saveAllAudioTags: function () {
      const that = this
      const changedList = this.audioPackList.filter(function (item) {
        return that.canEditToday(item.createTime) && that.hasAudioTagChanged(item)
      })
      if (changedList.length === 0) {
        this.$message.info('没有需要保存的标签更改')
        return
      }
      this.showLoading = true
      const promises = changedList.map(function (item) {
        return that.requestUpdateAudioPack(item).then(function () {
          return { success: true }
        }).catch(function (err) {
          return { success: false, msg: err.message }
        })
      })
      Promise.all(promises).then(function (results) {
        that.showLoading = false
        const successCount = results.filter(function (r) { return r.success }).length
        const failCount = results.length - successCount
        if (failCount === 0) {
          that.$message.success(`已保存 ${successCount} 个标签`)
        } else if (successCount > 0) {
          that.$message.warning(`保存完成：成功 ${successCount} 个，失败 ${failCount} 个`)
        } else {
          const firstError = results.find(function (r) { return !r.success })
          that.showMsg(firstError ? firstError.msg : '保存失败')
        }
      })
    }
  },
  mounted() {
    this.$bus.$emit("setMenuActiveIndex", "1-2-3");
    const pendingSearchName = sessionStorage.getItem(AUDIO_PACK_PENDING_SEARCH_KEY);
    if (pendingSearchName) {
      sessionStorage.removeItem(AUDIO_PACK_PENDING_SEARCH_KEY);
      this.searchName = pendingSearchName;
    }
    this.getAudioPackList()
  }
}
</script>

<style scoped>
.font_box {
  width: 100%;
  min-height: 100%;
  background: white;
  border-radius: 5px;
  padding: 10px 20px;
}

.box_operation {
  width: 100%;
  padding: 20px 0;
}

.input_box {
  display: inline-block;
  width: 200px;
  margin: 0 10px;
  margin-top: 10px;
}

.btn_box {
  margin-top: 10px;
  height: 40px;
  margin-left: 20px;
  vertical-align: top;
  display: inline-block;
}

.input_box_select {
  width: 150px;
}

.data_box {
  width: 100%;
}

.preview_image {
  width: 80px;
  height: 80px;
}

.data_box /deep/ .el-table .warning-row {
  background: oldlace;
}

.data_box /deep/ .el-table .success-row {
  background: #f0f9eb;
}

.page {
  width: 100%;
  margin: 20px 0;
  text-align: center;
}

.table {
  /*position: fixed;*/
  height: 100%;
}
</style>
